import { useEffect, useState } from 'react'
import { api, type Info } from '../api'
import { openExternal } from '../telegram'

/**
 * The subscription terms or the support contact, over the page. The texts come from the server — the
 * same ones the bot answers /terms and /paysupport with — so the two can never say different things.
 */
export function InfoSheet({ topic, onClose }: { topic: 'terms' | 'support'; onClose: () => void }) {
  const [info, setInfo] = useState<Info | null>(null)
  const [failed, setFailed] = useState(false)

  useEffect(() => {
    api
      .getInfo()
      .then(setInfo)
      .catch(() => setFailed(true))
  }, [])

  return (
    <div className="sheet-backdrop" onClick={onClose}>
      <div className="sheet" role="dialog" aria-modal="true" onClick={(e) => e.stopPropagation()}>
        {failed && <p className="muted">Не удалось загрузить — попробуйте ещё раз.</p>}
        {!info && !failed && <div className="spinner" />}

        {info && topic === 'terms' && (
          <>
            <h1>{info.terms.title}</h1>
            <ul>
              {info.terms.points.map((point) => (
                <li key={point}>{point}</li>
              ))}
            </ul>
            <p className="muted">{info.terms.acceptance}</p>
          </>
        )}

        {info && topic === 'support' && (
          <>
            <h1>{info.support.title}</h1>
            {info.support.lines.map((line) => (
              <p key={line}>{line}</p>
            ))}
            {info.support.url && (
              <button className="button primary" onClick={() => openExternal(info.support.url!)}>
                Написать в поддержку
              </button>
            )}
          </>
        )}

        <button className="button" onClick={onClose}>
          Закрыть
        </button>
      </div>
    </div>
  )
}
